import React, { Fragment } from "react";
import { Card, Row, Col, Button } from 'react-bootstrap';
import '../../../../../styles/balanco.scss'

const Balanco = (props) => {

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchBalancosIn()
    }

    const editar = async (id) => {
        props.editar(id)
    }

    const setAno = async (id) => {
        props.ano(id)
    }
    const setTipo = async (id) => {
        props.tipo(id)
    }
    const setFundo = async (id) => {
        props.fundo(id)
    }


    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>Balanço {props.balanco.tipo} {props.balanco.fundo}/{props.balanco.ano}</Card.Title>
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.balanco._id)} variant='primary'>Editar</Button>
                    <Button type="button" className="botao-leis" onClick={() => setAno(props.balanco._id)} variant='primary'>Mudar Ano</Button>
                    <Button type='button' className="botao-leis" onClick={() => setTipo(props.balanco._id)} variant='primary'>Mudar Tipo</Button>
                    <Button type='button' className="botao-leis" onClick={() => setFundo(props.balanco._id)} variant='primary'>Mudar Fundo</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.balanco._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Balanco;